// This file is auto-generated by @hey-api/openapi-ts

import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  TDataShape,
} from './client'
import { client } from './client.gen'
import type {
  InfoInfoOpenapi3YamlData,
  InfoInfoOpenapi3YamlResponses,
  InfoVersionData,
  InfoVersionResponses,
  NfdActivityData,
  NfdActivityErrors,
  NfdActivityResponses,
  NfdAnalyticsData,
  NfdAnalyticsErrors,
  NfdAnalyticsResponses,
  NfdBadgesData,
  NfdBadgesErrors,
  NfdBadgesResponses,
  NfdBlueskyLeadersData,
  NfdBlueskyLeadersErrors,
  NfdBlueskyLeadersResponses,
  NfdBrowseData,
  NfdBrowseErrors,
  NfdBrowseResponses,
  NfdConsensusLeadersData,
  NfdConsensusLeadersErrors,
  NfdConsensusLeadersResponses,
  NfdConsensusMetricsData,
  NfdConsensusMetricsErrors,
  NfdConsensusMetricsResponses,
  NfdContractLockData,
  NfdContractLockErrors,
  NfdContractLockResponses,
  NfdContractUpgradeData,
  NfdContractUpgradeErrors,
  NfdContractUpgradeResponses,
  NfdContractUpgradeV3Data,
  NfdContractUpgradeV3Errors,
  NfdContractUpgradeV3Responses,
  NfdDonationLeadersV2Data,
  NfdDonationLeadersV2Errors,
  NfdDonationLeadersV2Responses,
  NfdDonationListV2Data,
  NfdDonationListV2Errors,
  NfdDonationListV2Responses,
  NfdDonationsData,
  NfdDonationsErrors,
  NfdDonationsResponses,
  NfdGetLookupData,
  NfdGetLookupErrors,
  NfdGetLookupResponses,
  NfdGetNameSigData,
  NfdGetNameSigErrors,
  NfdGetNameSigResponses,
  NfdGetNfdData,
  NfdGetNfdErrors,
  NfdGetNfdResponses,
  NfdGetNfdsForAddressesV2Data,
  NfdGetNfdsForAddressesV2Errors,
  NfdGetNfdsForAddressesV2Responses,
  NfdGetQuoteData,
  NfdGetQuoteErrors,
  NfdGetQuoteResponses,
  NfdGetRevAddressSigData,
  NfdGetRevAddressSigErrors,
  NfdGetRevAddressSigResponses,
  NfdIsValidAsaData,
  NfdIsValidAsaErrors,
  NfdIsValidAsaResponses,
  NfdIsValidNfdData,
  NfdIsValidNfdErrors,
  NfdIsValidNfdResponses,
  NfdLinkAddressData,
  NfdLinkAddressErrors,
  NfdLinkAddressResponses,
  NfdMintData,
  NfdMintErrors,
  NfdMintResponses,
  NfdOfferData,
  NfdOfferErrors,
  NfdOfferResponses,
  NfdPostOfferToOwnerData,
  NfdPostOfferToOwnerErrors,
  NfdPostOfferToOwnerResponses,
  NfdPurchaseData,
  NfdPurchaseErrors,
  NfdPurchaseResponses,
  NfdRenewData,
  NfdRenewErrors,
  NfdRenewResponses,
  NfdRescindOfferData,
  NfdRescindOfferErrors,
  NfdRescindOfferResponses,
  NfdSearchV2Data,
  NfdSearchV2Errors,
  NfdSearchV2Responses,
  NfdSegmentLeadersData,
  NfdSegmentLeadersErrors,
  NfdSegmentLeadersResponses,
  NfdSegmentLockData,
  NfdSegmentLockErrors,
  NfdSegmentLockResponses,
  NfdSendFromVaultData,
  NfdSendFromVaultErrors,
  NfdSendFromVaultResponses,
  NfdSendToVaultData,
  NfdSendToVaultErrors,
  NfdSendToVaultResponses,
  NfdSetPrimaryAddressData,
  NfdSetPrimaryAddressErrors,
  NfdSetPrimaryAddressResponses,
  NfdSetPrimaryNfdData,
  NfdSetPrimaryNfdErrors,
  NfdSetPrimaryNfdResponses,
  NfdSuggestData,
  NfdSuggestErrors,
  NfdSuggestResponses,
  NfdTotalsData,
  NfdTotalsErrors,
  NfdTotalsResponses,
  NfdTwitterLeadersData,
  NfdTwitterLeadersErrors,
  NfdTwitterLeadersResponses,
  NfdUnlinkAddressData,
  NfdUnlinkAddressErrors,
  NfdUnlinkAddressResponses,
  NfdUpdateAllData,
  NfdUpdateAllErrors,
  NfdUpdateAllResponses,
  NfdUpdateImageData,
  NfdUpdateImageErrors,
  NfdUpdateImageResponses,
  NfdUpdatePartialData,
  NfdUpdatePartialErrors,
  NfdUpdatePartialResponses,
  NfdVaultOptInLockData,
  NfdVaultOptInLockErrors,
  NfdVaultOptInLockResponses,
  NfdVerifyConfirmData,
  NfdVerifyConfirmErrors,
  NfdVerifyConfirmResponses,
  NfdVerifyRequestData,
  NfdVerifyRequestErrors,
  NfdVerifyRequestResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

/**
 * Download ./pubfiles/openapi3.yaml
 *
 * YAML document containing the API swagger definition
 */
export const info_InfoOpenapi3Yaml = <ThrowOnError extends boolean = false>(
  options?: Options<InfoInfoOpenapi3YamlData, ThrowOnError>,
): RequestResult<InfoInfoOpenapi3YamlResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    InfoInfoOpenapi3YamlResponses,
    unknown,
    ThrowOnError
  >({ url: '/info/openapi3.yaml', ...options })

/**
 * version info
 *
 * Returns version information for the service
 */
export const info_version = <ThrowOnError extends boolean = false>(
  options?: Options<InfoVersionData, ThrowOnError>,
): RequestResult<InfoVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InfoVersionResponses, unknown, ThrowOnError>({
    url: '/info/version',
    ...options,
  })

/**
 * Get a specific NFD by name or by its application ID
 *
 * Get a specific NFD by name or by its application ID
 */
export const nfd_getNfd = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetNfdData, ThrowOnError>,
): RequestResult<NfdGetNfdResponses, NfdGetNfdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdGetNfdResponses,
    NfdGetNfdErrors,
    ThrowOnError
  >({ url: '/nfd/{nameOrID}', ...options })

/**
 * Fetch change activity for an NFD
 *
 * Fetch change activity for an NFD, specifically general 'block-level' deltas for an NFD
 */
export const nfd_activity = <ThrowOnError extends boolean = false>(
  options: Options<NfdActivityData, ThrowOnError>,
): RequestResult<NfdActivityResponses, NfdActivityErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdActivityResponses,
    NfdActivityErrors,
    ThrowOnError
  >({ url: '/nfd/activity', ...options })

/**
 * Fetch NFD analytics via various filters
 *
 * Fetch NFD analytics via various filters
 */
export const nfd_analytics = <ThrowOnError extends boolean = false>(
  options?: Options<NfdAnalyticsData, ThrowOnError>,
): RequestResult<NfdAnalyticsResponses, NfdAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    NfdAnalyticsResponses,
    NfdAnalyticsErrors,
    ThrowOnError
  >({ url: '/nfd/analytics', ...options })

/**
 * Fetch badge information (donations/etc) for an NFD
 *
 * Fetch badge information (ie: donations) for an NFD
 */
export const nfd_badges = <ThrowOnError extends boolean = false>(
  options: Options<NfdBadgesData, ThrowOnError>,
): RequestResult<NfdBadgesResponses, NfdBadgesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdBadgesResponses,
    NfdBadgesErrors,
    ThrowOnError
  >({ url: '/nfd/badges/{name}', ...options })

/**
 * blueskyLeaders nfd
 *
 * Get top bluesky influencers
 */
export const nfd_blueskyLeaders = <ThrowOnError extends boolean = false>(
  options?: Options<NfdBlueskyLeadersData, ThrowOnError>,
): RequestResult<
  NfdBlueskyLeadersResponses,
  NfdBlueskyLeadersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdBlueskyLeadersResponses,
    NfdBlueskyLeadersErrors,
    ThrowOnError
  >({ url: '/nfd/bluesky/leaders', ...options })

/**
 * Browse NFDs via various filters
 */
export const nfd_browse = <ThrowOnError extends boolean = false>(
  options?: Options<NfdBrowseData, ThrowOnError>,
): RequestResult<NfdBrowseResponses, NfdBrowseErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    NfdBrowseResponses,
    NfdBrowseErrors,
    ThrowOnError
  >({ url: '/nfd/browse', ...options })

/**
 * consensusLeaders nfd
 *
 * Get top consensus leaders
 */
export const nfd_consensusLeaders = <ThrowOnError extends boolean = false>(
  options?: Options<NfdConsensusLeadersData, ThrowOnError>,
): RequestResult<
  NfdConsensusLeadersResponses,
  NfdConsensusLeadersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdConsensusLeadersResponses,
    NfdConsensusLeadersErrors,
    ThrowOnError
  >({ url: '/nfd/consensus/leaders', ...options })

/**
 * consensusMetrics nfd
 *
 * Get general metrics about Algorand consensus
 */
export const nfd_consensusMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<NfdConsensusMetricsData, ThrowOnError>,
): RequestResult<
  NfdConsensusMetricsResponses,
  NfdConsensusMetricsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdConsensusMetricsResponses,
    NfdConsensusMetricsErrors,
    ThrowOnError
  >({ url: '/nfd/consensus/metrics', ...options })

/**
 * contractLock nfd
 *
 * Lock/Unlock an NFD contract - if locked, the contract can never being modified until unlocked again by the owner.
 */
export const nfd_contractLock = <ThrowOnError extends boolean = false>(
  options: Options<NfdContractLockData, ThrowOnError>,
): RequestResult<
  NfdContractLockResponses,
  NfdContractLockErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdContractLockResponses,
    NfdContractLockErrors,
    ThrowOnError
  >({
    url: '/nfd/contract/lock/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * contractUpgrade nfd
 *
 * Request upgrade of a pre 2.11 NFD to 2.11 (going no further)
 */
export const nfd_contractUpgrade = <ThrowOnError extends boolean = false>(
  options: Options<NfdContractUpgradeData, ThrowOnError>,
): RequestResult<
  NfdContractUpgradeResponses,
  NfdContractUpgradeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdContractUpgradeResponses,
    NfdContractUpgradeErrors,
    ThrowOnError
  >({
    url: '/nfd/contract/upgrade/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * donations nfd
 *
 * Fetch donation activity for an NFD, totalling amounts sent 'to' designated donation accounts
 */
export const nfd_donations = <ThrowOnError extends boolean = false>(
  options: Options<NfdDonationsData, ThrowOnError>,
): RequestResult<NfdDonationsResponses, NfdDonationsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdDonationsResponses,
    NfdDonationsErrors,
    ThrowOnError
  >({ url: '/nfd/donations/{name}', ...options })

/**
 * getQuote nfd
 *
 * get price / carry cost to mint or rewnew an NFD (if existing)
 */
export const nfd_getQuote = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetQuoteData, ThrowOnError>,
): RequestResult<NfdGetQuoteResponses, NfdGetQuoteErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdGetQuoteResponses,
    NfdGetQuoteErrors,
    ThrowOnError
  >({ url: '/nfd/getQuote/{name}', ...options })

/**
 * isValidNFD nfd
 *
 * Determines if specified NFD Application ID is authentic
 */
export const nfd_isValidNfd = <ThrowOnError extends boolean = false>(
  options: Options<NfdIsValidNfdData, ThrowOnError>,
): RequestResult<NfdIsValidNfdResponses, NfdIsValidNfdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdIsValidNfdResponses,
    NfdIsValidNfdErrors,
    ThrowOnError
  >({ url: '/nfd/isValid/{appID}', ...options })

/**
 * isValidASA nfd
 *
 * Determines if specified NFD NFT ASA ID is authentic NFD
 */
export const nfd_isValidAsa = <ThrowOnError extends boolean = false>(
  options: Options<NfdIsValidAsaData, ThrowOnError>,
): RequestResult<NfdIsValidAsaResponses, NfdIsValidAsaErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdIsValidAsaResponses,
    NfdIsValidAsaErrors,
    ThrowOnError
  >({ url: '/nfd/isValidASA/{asaID}', ...options })

/**
 * linkAddress nfd
 *
 * Link one or more addresses to an NFD, adding to the reverse-address lookups as well as to this NFD.  Sender must be owner, and each added address must be able to be signed for.
 */
export const nfd_linkAddress = <ThrowOnError extends boolean = false>(
  options: Options<NfdLinkAddressData, ThrowOnError>,
): RequestResult<NfdLinkAddressResponses, NfdLinkAddressErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdLinkAddressResponses,
    NfdLinkAddressErrors,
    ThrowOnError
  >({
    url: '/nfd/links/addAddress/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * unlinkAddress nfd
 *
 * UnLink one or more addresses to an NFD, adding to the reverse-address lookups as well as to this NFD.  Sender must be owner, and each added address must be able to be signed for.
 */
export const nfd_unlinkAddress = <ThrowOnError extends boolean = false>(
  options: Options<NfdUnlinkAddressData, ThrowOnError>,
): RequestResult<
  NfdUnlinkAddressResponses,
  NfdUnlinkAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdUnlinkAddressResponses,
    NfdUnlinkAddressErrors,
    ThrowOnError
  >({
    url: '/nfd/links/removeAddress/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * setPrimaryAddress nfd
 *
 * Set which of the currently verified addresses should be the first in the list (swapping positions as necessary)
 */
export const nfd_setPrimaryAddress = <ThrowOnError extends boolean = false>(
  options: Options<NfdSetPrimaryAddressData, ThrowOnError>,
): RequestResult<
  NfdSetPrimaryAddressResponses,
  NfdSetPrimaryAddressErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdSetPrimaryAddressResponses,
    NfdSetPrimaryAddressErrors,
    ThrowOnError
  >({
    url: '/nfd/links/setPrimaryAddress/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * setPrimaryNFD nfd
 *
 * Set the specified NFD as the primary NFD to return for the specified address via its reverse lookup
 */
export const nfd_setPrimaryNfd = <ThrowOnError extends boolean = false>(
  options: Options<NfdSetPrimaryNfdData, ThrowOnError>,
): RequestResult<
  NfdSetPrimaryNfdResponses,
  NfdSetPrimaryNfdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdSetPrimaryNfdResponses,
    NfdSetPrimaryNfdErrors,
    ThrowOnError
  >({
    url: '/nfd/links/setPrimaryNFD/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Reverse Address lookup with results returned per address
 *
 * Get the primary NFD for an address.  Must be verified address, or if allowUnverified is set, it may match against an unverified address
 */
export const nfd_getLookup = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetLookupData, ThrowOnError>,
): RequestResult<NfdGetLookupResponses, NfdGetLookupErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdGetLookupResponses,
    NfdGetLookupErrors,
    ThrowOnError
  >({ url: '/nfd/lookup', ...options })

/**
 * mint nfd
 *
 * Mint a new NFD, with user buying specified NFD and paying for a prorated amount of time based on its yearly price.
 */
export const nfd_mint = <ThrowOnError extends boolean = false>(
  options: Options<NfdMintData, ThrowOnError>,
): RequestResult<NfdMintResponses, NfdMintErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdMintResponses,
    NfdMintErrors,
    ThrowOnError
  >({
    url: '/nfd/mint',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * getNameSig nfd
 *
 * Returns NameSig address for an NFD name (usable for V1 only)
 */
export const nfd_getNameSig = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetNameSigData, ThrowOnError>,
): RequestResult<NfdGetNameSigResponses, NfdGetNameSigErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdGetNameSigResponses,
    NfdGetNameSigErrors,
    ThrowOnError
  >({ url: '/nfd/nameSig/{name}', ...options })

/**
 * offer nfd
 *
 * Offer up an NFD for sale - specifying price and optionally an address it is reserved for.
 */
export const nfd_offer = <ThrowOnError extends boolean = false>(
  options: Options<NfdOfferData, ThrowOnError>,
): RequestResult<NfdOfferResponses, NfdOfferErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdOfferResponses,
    NfdOfferErrors,
    ThrowOnError
  >({
    url: '/nfd/offer/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * postOfferToOwner nfd
 *
 * Post an offer to buy to the owner of an NFD, offering up a particular amount with optional note for them to consider
 */
export const nfd_postOfferToOwner = <ThrowOnError extends boolean = false>(
  options: Options<NfdPostOfferToOwnerData, ThrowOnError>,
): RequestResult<
  NfdPostOfferToOwnerResponses,
  NfdPostOfferToOwnerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdPostOfferToOwnerResponses,
    NfdPostOfferToOwnerErrors,
    ThrowOnError
  >({
    url: '/nfd/postOfferToOwner/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * purchase nfd
 *
 * Purchase an NFD for sale - specifying buyer (to sign transaction) and price
 */
export const nfd_purchase = <ThrowOnError extends boolean = false>(
  options: Options<NfdPurchaseData, ThrowOnError>,
): RequestResult<NfdPurchaseResponses, NfdPurchaseErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdPurchaseResponses,
    NfdPurchaseErrors,
    ThrowOnError
  >({
    url: '/nfd/purchase/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * renew nfd
 *
 * Renew or extend the expiration of an NFD.  If current owner, renews at base price. If other owner, can take ownership but goes through reverse auction process for first 28 days where price drops to base price - with price being for 1 year
 */
export const nfd_renew = <ThrowOnError extends boolean = false>(
  options: Options<NfdRenewData, ThrowOnError>,
): RequestResult<NfdRenewResponses, NfdRenewErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdRenewResponses,
    NfdRenewErrors,
    ThrowOnError
  >({
    url: '/nfd/renew',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * rescindOffer nfd
 *
 * Rescind offer of sale. Claiming NFD back for self, and removing it for sale.
 */
export const nfd_rescindOffer = <ThrowOnError extends boolean = false>(
  options: Options<NfdRescindOfferData, ThrowOnError>,
): RequestResult<
  NfdRescindOfferResponses,
  NfdRescindOfferErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdRescindOfferResponses,
    NfdRescindOfferErrors,
    ThrowOnError
  >({
    url: '/nfd/rescindOffer/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * getRevAddressSig nfd
 *
 * Returns RevAddress address for an NFD name (usable for V1 only)
 */
export const nfd_getRevAddressSig = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetRevAddressSigData, ThrowOnError>,
): RequestResult<
  NfdGetRevAddressSigResponses,
  NfdGetRevAddressSigErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    NfdGetRevAddressSigResponses,
    NfdGetRevAddressSigErrors,
    ThrowOnError
  >({ url: '/nfd/revAddressSig/{address}', ...options })

/**
 * segmentLeaders nfd
 *
 * Get top segment roots
 */
export const nfd_segmentLeaders = <ThrowOnError extends boolean = false>(
  options?: Options<NfdSegmentLeadersData, ThrowOnError>,
): RequestResult<
  NfdSegmentLeadersResponses,
  NfdSegmentLeadersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdSegmentLeadersResponses,
    NfdSegmentLeadersErrors,
    ThrowOnError
  >({ url: '/nfd/segment/leaders', ...options })

/**
 * Lock/Unlock an NFD segment - specifying open price if unlocking
 *
 * Lock/Unlock an NFD segment - if locked, the segment only allows minted names created by the segment owner.  If unlocked, anyone can mint off the segment for the price (in USD) the owner sets
 */
export const nfd_segmentLock = <ThrowOnError extends boolean = false>(
  options: Options<NfdSegmentLockData, ThrowOnError>,
): RequestResult<NfdSegmentLockResponses, NfdSegmentLockErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdSegmentLockResponses,
    NfdSegmentLockErrors,
    ThrowOnError
  >({
    url: '/nfd/segment/lock/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * suggest nfd
 *
 * Suggest NFDs to purchase
 */
export const nfd_suggest = <ThrowOnError extends boolean = false>(
  options: Options<NfdSuggestData, ThrowOnError>,
): RequestResult<NfdSuggestResponses, NfdSuggestErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NfdSuggestResponses,
    NfdSuggestErrors,
    ThrowOnError
  >({ url: '/nfd/suggest/{name}', ...options })

/**
 * totals nfd
 *
 * Fetch NFD summary data - results subject to change in the future
 */
export const nfd_totals = <ThrowOnError extends boolean = false>(
  options?: Options<NfdTotalsData, ThrowOnError>,
): RequestResult<NfdTotalsResponses, NfdTotalsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    NfdTotalsResponses,
    NfdTotalsErrors,
    ThrowOnError
  >({ url: '/nfd/totals', ...options })

/**
 * twitterLeaders nfd
 *
 * Get top twitter influencers
 */
export const nfd_twitterLeaders = <ThrowOnError extends boolean = false>(
  options?: Options<NfdTwitterLeadersData, ThrowOnError>,
): RequestResult<
  NfdTwitterLeadersResponses,
  NfdTwitterLeadersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdTwitterLeadersResponses,
    NfdTwitterLeadersErrors,
    ThrowOnError
  >({ url: '/nfd/twitter/leaders', ...options })

/**
 * updatePartial nfd
 *
 * Set an attribute in an NFD on behalf of a particular sender (who must be the owner).  Can set user-defined fields, or clear verified fields (except v.ca*)
 */
export const nfd_updatePartial = <ThrowOnError extends boolean = false>(
  options: Options<NfdUpdatePartialData, ThrowOnError>,
): RequestResult<
  NfdUpdatePartialResponses,
  NfdUpdatePartialErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    NfdUpdatePartialResponses,
    NfdUpdatePartialErrors,
    ThrowOnError
  >({
    url: '/nfd/update/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * updateAll nfd
 *
 * Replace all NFD user-settable attributes with those passed-in, removing, adding and replacing on behalf of a particular sender (who must be the owner).  Returns transaction group of transactions to sign
 */
export const nfd_updateAll = <ThrowOnError extends boolean = false>(
  options: Options<NfdUpdateAllData, ThrowOnError>,
): RequestResult<NfdUpdateAllResponses, NfdUpdateAllErrors, ThrowOnError> =>
  (options.client ?? client).put<
    NfdUpdateAllResponses,
    NfdUpdateAllErrors,
    ThrowOnError
  >({
    url: '/nfd/update/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * updateImage nfd
 *
 * Update the avatar or banner image associated with an NFD by uploading new image content
 */
export const nfd_updateImage = <ThrowOnError extends boolean = false>(
  options: Options<NfdUpdateImageData, ThrowOnError>,
): RequestResult<NfdUpdateImageResponses, NfdUpdateImageErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdUpdateImageResponses,
    NfdUpdateImageErrors,
    ThrowOnError
  >({ url: '/nfd/updateImage/{name}/{sender}/{which}', ...options })

/**
 * Reverse Address lookup with results returned per address
 *
 * Get all NFDs which have been explicitly linked to one or more verified [or unverified] Algorand address(es).  Unverified addresses will match but return as unverifiedCaAlgo array.  These should be treated specially and not have the same trust level as verified addresses as they can be falsely attributed.  The caAlgo array is what should be trusted for things like NFT creation addresses. For reverse lookups returning multiple NFDs, the first result should be used.
 */
export const nfd_getNfdsForAddressesV2 = <ThrowOnError extends boolean = false>(
  options: Options<NfdGetNfdsForAddressesV2Data, ThrowOnError>,
): RequestResult<
  NfdGetNfdsForAddressesV2Responses,
  NfdGetNfdsForAddressesV2Errors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    NfdGetNfdsForAddressesV2Responses,
    NfdGetNfdsForAddressesV2Errors,
    ThrowOnError
  >({ url: '/nfd/v2/address', ...options })

/**
 * donationLeadersV2 nfd
 *
 * Get top donors to a specific NFD Donation target
 */
export const nfd_donationLeadersV2 = <ThrowOnError extends boolean = false>(
  options: Options<NfdDonationLeadersV2Data, ThrowOnError>,
): RequestResult<
  NfdDonationLeadersV2Responses,
  NfdDonationLeadersV2Errors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    NfdDonationLeadersV2Responses,
    NfdDonationLeadersV2Errors,
    ThrowOnError
  >({ url: '/nfd/v2/donations/leaders/{name}', ...options })

/**
 * donationListV2 nfd
 *
 * Fetch list of tracked Donation NFD 'targets'.
 */
export const nfd_donationListV2 = <ThrowOnError extends boolean = false>(
  options?: Options<NfdDonationListV2Data, ThrowOnError>,
): RequestResult<
  NfdDonationListV2Responses,
  NfdDonationListV2Errors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    NfdDonationListV2Responses,
    NfdDonationListV2Errors,
    ThrowOnError
  >({ url: '/nfd/v2/donations/list', ...options })

/**
 * Search NFDs via various filters
 *
 * Search NFDs via various filters
 */
export const nfd_searchV2 = <ThrowOnError extends boolean = false>(
  options?: Options<NfdSearchV2Data, ThrowOnError>,
): RequestResult<NfdSearchV2Responses, NfdSearchV2Errors, ThrowOnError> =>
  (options?.client ?? client).get<
    NfdSearchV2Responses,
    NfdSearchV2Errors,
    ThrowOnError
  >({ url: '/nfd/v2/search', ...options })

/**
 * ContractUpgradeV3 nfd
 *
 * Request upgrade of a 2.11 or 3.x NFD to 3.x+ (post renewals). First switch to 3.x will pay 1 year renewal fee
 */
export const nfd_ContractUpgradeV3 = <ThrowOnError extends boolean = false>(
  options: Options<NfdContractUpgradeV3Data, ThrowOnError>,
): RequestResult<
  NfdContractUpgradeV3Responses,
  NfdContractUpgradeV3Errors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdContractUpgradeV3Responses,
    NfdContractUpgradeV3Errors,
    ThrowOnError
  >({
    url: '/nfd/v3/contract/upgrade/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * vaultOptInLock nfd
 *
 * Lock/Unlock ability for the specified NFD Vault to auto opt-in to assets, allowing airdrops from other accounts
 */
export const nfd_vaultOptInLock = <ThrowOnError extends boolean = false>(
  options: Options<NfdVaultOptInLockData, ThrowOnError>,
): RequestResult<
  NfdVaultOptInLockResponses,
  NfdVaultOptInLockErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdVaultOptInLockResponses,
    NfdVaultOptInLockErrors,
    ThrowOnError
  >({
    url: '/nfd/vault/lock/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * sendFromVault nfd
 *
 * Send an amount of an asset [0 == ALGO] to another account FROM the NFD Vault.  Only owner of NFD can send.
 */
export const nfd_sendFromVault = <ThrowOnError extends boolean = false>(
  options: Options<NfdSendFromVaultData, ThrowOnError>,
): RequestResult<
  NfdSendFromVaultResponses,
  NfdSendFromVaultErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdSendFromVaultResponses,
    NfdSendFromVaultErrors,
    ThrowOnError
  >({
    url: '/nfd/vault/sendFrom/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * sendToVault nfd
 *
 * Provide transaction to send an asset owned by sender account to an NFD vault.  Call to have opt-in to vault will be included if necessary.  Callable by NFD owner, or if Opt-in is UNLOCKED (or asset already opted-in), anyone can call
 */
export const nfd_sendToVault = <ThrowOnError extends boolean = false>(
  options: Options<NfdSendToVaultData, ThrowOnError>,
): RequestResult<NfdSendToVaultResponses, NfdSendToVaultErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NfdSendToVaultResponses,
    NfdSendToVaultErrors,
    ThrowOnError
  >({
    url: '/nfd/vault/sendTo/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * verifyConfirm nfd
 *
 * Verify a particular piece of data on, or off-chain.  Each verification differs in its requirements
 */
export const nfd_verifyConfirm = <ThrowOnError extends boolean = false>(
  options: Options<NfdVerifyConfirmData, ThrowOnError>,
): RequestResult<
  NfdVerifyConfirmResponses,
  NfdVerifyConfirmErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdVerifyConfirmResponses,
    NfdVerifyConfirmErrors,
    ThrowOnError
  >({
    url: '/nfd/verify/confirm/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * verifyRequest nfd
 *
 * Request Verification for particular piece of data on, or off-chain.  Each verification differs in its requirements. Returns data to be used in challenge
 */
export const nfd_verifyRequest = <ThrowOnError extends boolean = false>(
  options: Options<NfdVerifyRequestData, ThrowOnError>,
): RequestResult<
  NfdVerifyRequestResponses,
  NfdVerifyRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NfdVerifyRequestResponses,
    NfdVerifyRequestErrors,
    ThrowOnError
  >({
    url: '/nfd/verify/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
